<template>
  <b-modal
    id="quickSearchAncillaryModal"
    size="lg"
    scrollable
    ok-only
    ok-title="Chiudi"
    ok-variant="-transparent"
    header-bg-variant="lisaweb"
    no-close-on-esc
  >
    <template #modal-header="{ cancel }">
      <div slot="modal-title" class="modal-title">
        <b-icon icon="file-text"></b-icon>
        <span>Cerca Titoli</span>
      </div>
      <button
        type="button"
        class="close"
        title="Chiudi"
        data-dismiss="modal"
        @click="cancel()"
      >
        <base-icon name="close" width="14" height="14"/>
      </button>
    </template>
    <div style="display: flex; flex-direction: column; height: 80vh;">
      <b-form class="mt-2" @submit.prevent="onSearch(filterName)">
        <b-row>
          <div class="col-md-4">
            <base-select
              name="Compagnia"
              label="Compagnia"
              :options="companies"
              v-model="filter.byInsurer.id"
            />
          </div>
          <div class="col-md-4">
            <base-input
              name="Polizza"
              type="text"
              label="Numero Polizza"
              v-model="filter.byInsurancePolicy.number"
              placeholder="Inserisci un numero polizza"
            />
          </div>
          <div class="form-group d-flex col-md-4 align-self-end">
            <b-button type="submit" class="mr-2 btn--smaller" variant="lisaweb" size="sm">Cerca</b-button>
            <b-button
              class="btn-reset btn--transparent btn--smaller"
              type="button"
              size="sm"
              @click="onClearFilter(filterName)"
            >Reset
            </b-button
            >
          </div>
        </b-row>
      </b-form>

      <insurance-ancillaries
        :isTableInModal="true"
        :fields="fields"
        :repository="repository"
        :resource="resource"
        :filterName="filterName"
        :ref="tableRef"
        :filterOn="{
        byRelations: [],
      }"
        noInnerWidth
        noActions
        includeRowSelector
        noInputPaginator
        @rowSelector="onModalSelector"
      >
      </insurance-ancillaries>
    </div>
  </b-modal>
</template>
<script>
import BaseInput from "@/components/form/BaseInput";
import BaseSelect from "@/components/form/BaseSelect";
import BaseIcon from "@/components/BaseIcon";
// import InsuranceAncillaries from "@/components/tables/InsuranceAncillaries";
import {mapActions, mapGetters} from "vuex";
import CustomFiltersMixin from "@/mixins/CustomFiltersMixin";

export default {
  mixins: [CustomFiltersMixin],
  data() {
    return {
      filter: this.initFilter(),
      filterName: "filterQuickSearchAncillary",
      repository: "insurance_ancillary",
      resource: "insurance_ancillaries",
      tableRef: "QuickSearchAncillaryTableRef",
      companies: [],
      titoli: [
        {value: "0", text: "Da incassare"},
        {value: "1", text: "Incassato"},
        {value: "2", text: "Stornati"},
        {value: "3", text: "Annullati manualmente"},
        {value: "4", text: "Annullati manualmente + annullo polizza"},
        {value: "5", text: "Annullati su piattaforma compagnia"},
        {value: "6", text: "Annullati per sostituzione"},
      ],
      tipo_titoli: [
        {value: "P", text: "Polizze"},
        {value: "Q", text: "Quietanze"},
        {value: "A", text: "Appendici"},
        // { value: "X", text: "Pregresso" },
      ],
      fields: [
        {
          key: "rowSelector2",
          label: "",
          thStyle: {
            width: "20px",
          },
        },
        {
          key: "insurance_policy.number",
          label: this.getDictionary("number", "insurance_policy"),
        },
        {
          key: "insurance_policy.title",
          label: this.getDictionary("Descrizione Polizza"),
        },
      ],
    };
  },
  components: {
    InsuranceAncillaries: () =>
      import("@/components/tables/InsuranceAncillaries"),
    // InsuranceAncillaries,
    BaseInput,
    BaseSelect,
    BaseIcon,
  },
  methods: {
    initFilter() {
      let init = {
        byAttribute: {
          status_ancillary: "0",
          code: ["P", "A"],
        },
        byInsurancePolicy: {
          number: null,
        },
        byInsurer: {
          id: null,
        },
      };
      return init;
    },
    onSearch(name) {
      let criteria = this.filter;
      this.saveFilterByName({name, criteria});
      this.removePaginationByName(name);
      this.$refs[this.tableRef].currentPage = 1;
      this.$refs[this.tableRef].fetch().then(() => {
        this.removeFilterByName(name);
      });
    },
    onClearFilter(name) {
      this.resetFilter();
      this.removeFilterByName(name);
      this.removePaginationByName(name);
      this.removeSortByName(name);
      // this.onSearch(name);
    },
    ...mapActions("filters", {
      saveFilterByName: "saveByName",
      removeFilterByName: "removeByName",
    }),
    ...mapActions("pagination", {removePaginationByName: "removeByName"}),
    ...mapActions("sorts", {
      removeSortByName: "removeByName",
    }),
    ...mapGetters("auth", {
      getInsurers: "insurers",
    }),
    onModalSelector(val) {
      this.$emit("input", val);
    },
  },
  mounted() {
    this.companies = this.getInsurers();
  },
};
</script>
